import config from 'config';

import { plusSizes } from '../constants/productSizes';

/**
 * Checks if any of the users profile sizes are in the brand's set of plus sizes
 */
export function getIsPlusProfile(profileSizes) {
  if (!profileSizes) {
    return false;
  }
  const excludeProfileSizeFilters = config.get(
    'public.brand.excludeProfileSizeFilters'
  );
  excludeProfileSizeFilters.forEach((sizeFilter) => {
    if (profileSizes[sizeFilter]) {
      delete profileSizes[sizeFilter];
    }
  });

  return Object.values(profileSizes).some((profileSize) =>
    plusSizes.has(profileSize)
  );
}
